(() => {
  if (window.__bewoNoticeInit) return;
  window.__bewoNoticeInit = true;

  const setOpen = (notice, open) => {
    const toggle = notice.querySelector('[data-bewo-notice-toggle]');
    const pop = notice.querySelector('.bewo-notice__pop');
    if (!toggle || !pop) return;
    pop.hidden = !open;
    toggle.setAttribute('aria-expanded', String(open));
  };

  const closeAll = (except) => {
    document.querySelectorAll('[data-bewo-notice]').forEach((notice) => {
      if (notice !== except) setOpen(notice, false);
    });
  };

  document.addEventListener('click', (e) => {
    const toggle = e.target.closest('[data-bewo-notice-toggle]');
    if (toggle) {
      const notice = toggle.closest('[data-bewo-notice]');
      closeAll(notice);
      setOpen(notice, toggle.getAttribute('aria-expanded') !== 'true');
      return;
    }
    const close = e.target.closest('[data-bewo-notice-close]');
    if (close) {
      const notice = close.closest('[data-bewo-notice]');
      setOpen(notice, false);
      notice.querySelector('[data-bewo-notice-toggle]')?.focus();
      return;
    }
    if (!e.target.closest('[data-bewo-notice]')) closeAll();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAll();
  });
})();
